export default function () {
    const title = document.querySelector('.hero-home-title');
    if (!title) return;

    const words = title.innerText.trim().split(/\s+/);
    title.innerText = ''

    const createRow = () => {
        const row = document.createElement('div');
        row.classList.add('hero-home-title__row')
        return row
    }

    const rows = [1, 2, 2]
    let wIndex = 0
    let delay = 0

    rows.forEach(size => {
        if (wIndex >= words.length) return;
        const row = createRow()

        for (let i = 0; i < size && wIndex < words.length; i++, wIndex++) {
            const w = words[wIndex]

            const isLast = words.length === (wIndex + 1)
            delay += isLast ? .5 : wIndex === 0 ? 0 : .3

            const tWord = document.createElement('div')
            tWord.classList.add('hero-home-title__word');
            tWord.innerHTML = `<div class="d-inline-block" style="animation-delay: ${delay}s">${w}</div>`
            row.appendChild(tWord)
        }

        title.appendChild(row)
    })
}